// 退单列表
import React, { Fragment } from "react";
import {
  Input,
  Button,
  Table,
  message,
  Select,
  DatePicker,
  Modal,
  Popover,
  Tooltip,
  Spin,
  Radio
} from "antd";
import { CopyOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { API, ROOT, IconFont } from "../../../static/js/common";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";

const { Option } = Select;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

class AutoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      autoUrl: "",
      loading: false,
      loadingCancel: false,
      inputType: null,
    };
  }

  handleSubmit = () => {
    this.setState({ loading: true });
    API.getAutoList({}).then((res) => {
      this.setState({ loading: false });
      if (res.extData.url) {
        window.open(res.extData.url, '_blank')
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
  };

  handleTaoSubmit = () => {
    this.setState({ loading: true });
    let phone = window.localStorage.getItem('phone');
    API.getTaoAutoList({}).then((res) => {
      this.setState({ loading: false });
      if (res.extData.url) {
        window.open(res.extData.url, '_blank')
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
  };

  // handleTaoSubmit = () => {
  //   this.setState({ loading: true });
  //   let phone = window.localStorage.getItem('phone');
  //   // mobile=${encodeURIComponent(phone)
    
  //   // 使用 fetch API 发送请求
  //   fetch(`http://dfadminapi.duoduolang.com/autoOrder/getTbShopAuthUrl?mobile=${phone}`, {
  //     method: 'GET',
  //     headers: {
  //       'Content-Type': 'application/json',
  //       // 如果需要其他头部信息，可以在这里添加
  //       // 'Authorization': 'Bearer your-token'
  //     }
  //   })
  //   .then(response => {
  //     if (!response.ok) {
  //       throw new Error('网络请求失败');
  //     }
  //     return response.json();
  //   })
  //   .then(res => {
  //     this.setState({ loading: false });
  //     if (res.extData) {
  //       window.open(res.extData, '_blank');
  //     } else {
  //       message.error(res.message || "数据加载错误");
  //     }
  //   })
  //   .catch(error => {
  //     this.setState({ loading: false });
  //     message.error("请求失败，请重试");
  //     console.error('API请求错误:', error);
  //   });
  // };

  handleDouSubmit = () => {
    this.setState({ loading: true });
    API.getDouAutoList({}).then((res) => {
      this.setState({ loading: false });
      if (res.extData.url) {
        window.open(res.extData.url, '_blank')
      } else {
        message.error(res.message || "数据加载错误");
      }
    });
  };

  handleJinSubmit = () => {
    this.setState({ loading: true });
    API.getJinAutoList({}).then((res) => {
      this.setState({ loading: false });
      if (res.extData.url) {
        window.open(res.extData.url, '_blank')
      } else {
        message.error(res.extData.message || "数据加载错误");
      }
    });
  };

  handleCancel = () => {
    this.setState({ loadingCancel: true });
    API.getCancelAuto({}).then((res) => {
      this.setState({ loadingCancel: false });
      message.success("取消自动下单成功")
    });
  };

  handleTaoCancel = () => {
    this.setState({ loadingCancel: true });
    API.getCancelTaoAuto({}).then((res) => {
      this.setState({ loadingCancel: false });
      message.success("取消自动下单成功")
    });
  };

  handleDouCancel = () => {
    this.setState({ loadingCancel: true });
    API.getCancelDouAuto({}).then((res) => {
      this.setState({ loadingCancel: false });
      message.success("取消自动下单成功")
    });
  };

  handleJinCancel = () => {
    this.setState({ loadingCancel: true });
    API.getCancelJinAuto({}).then((res) => {
      this.setState({ loadingCancel: false });
      message.success("取消自动下单成功")
    });
  };


  render() {
    const {
      loading,
      loadingCancel,
      inputType
    } = this.state;

    return (
      <div>
        <div className="goods_info_platform">
          <div style={{ fontSize: 21, fontWeight: 500, marginBottom: 10 }}>
            {/* 加入自动下单流程 */}
          </div>
          <Radio.Group
            value={inputType}
            buttonStyle="solid"
            size="large"
            onChange={(e) => this.setState({ inputType: e.target.value })}
          >
            {/* <Radio.Button value={1}>拼多多</Radio.Button> */}
            {/* <Radio.Button value={2}>淘宝</Radio.Button> */}
            {/* <Radio.Button value={3}>抖音</Radio.Button> */}
            {/* <Radio.Button value={4}>京东</Radio.Button> */}
          </Radio.Group>
        </div>
        {
          inputType === 1 ? (
            <div style={{marginTop:'15px'}}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>1.</span>拼多多商家账号登录，购买“快打打单”服务
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              &nbsp;&nbsp;购买链接：
              <a
                href="https://fuwu.pinduoduo.com/service-market/service-detail?detailId=77695"
                target="_blank"
                style={{ cursor: 'pointer' }}>
                <span style={{ color: '#33AAFF' }}>https://fuwu.pinduoduo.com/service-market/service-detail?detailId=77695</span>
              </a>
            </div>
            <img
              src={require("../../../assets/auto.png")}
              alt=""
              style={{ width: 600, height: 280 }}
            />
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>2.</span>购买后，点击按钮“获取授权链接”，会跳转到新页面，使用拼多多商家主账号登录并授权
            </div>
            <div>
              <Button type="primary" onClick={this.handleSubmit} loading={loading} style={{ marginBottom: 10, marginLeft: 10 }}>
                获取授权链接
              </Button>
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>3.</span>在个人主页，可以看到绑定结果，可以看到店名就是绑定成功
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <br/>
              <span style={{ fontSize: 16 }}>注意：</span>
              如需取消自动下单，则点击下方“取消自动下单”按钮，
              提示取消成功则说明取消成功，也可前往个人中心确认自动下单绑定情况
            </div>
            <div>
              <Button type="primary" onClick={this.handleCancel} loading={loadingCancel} style={{ marginBottom: 10, marginLeft: 10 }}>
                取消自动下单
              </Button>
            </div>
          </div>
          ) :inputType===2 ? (
            <div style={{marginTop:'15px'}}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>1.</span>淘宝商家账号登录，购买“通天打印快递打折”服务
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              &nbsp;&nbsp;购买链接：
              <a
                href="https://kf.fw199.com/app/104"
                target="_blank"
                style={{ cursor: 'pointer' }}>
                <span style={{ color: '#33AAFF' }}>https://kf.fw199.com/app/104</span>
              </a>
            </div>
            <img
              src={require("../../../assets/tao2.png")}
              alt=""
              style={{ width: 600, height: 280 }}
            />
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>2.</span>购买后，点击按钮“获取授权链接”，会跳转到新页面，使用淘宝商家主账号登录并授权
            </div>
            <div>
              <Button type="primary" onClick={this.handleTaoSubmit} loading={loading} style={{ marginBottom: 10, marginLeft: 10 }}>
                获取授权链接
              </Button>
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>3.</span>在个人主页，可以看到绑定结果，可以看到店名就是绑定成功
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <br/>
              <span style={{ fontSize: 16 }}>注意：</span>
              如需取消自动下单，则点击下方“取消自动下单”按钮，
              提示取消成功则说明取消成功，也可前往个人中心确认自动下单绑定情况
            </div>
            <div>
              <Button type="primary" onClick={this.handleTaoCancel} loading={loadingCancel} style={{ marginBottom: 10, marginLeft: 10 }}>
                取消自动下单
              </Button>
            </div>
          </div>
          ):inputType===3 ? (
            <div style={{marginTop:'15px'}}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>1.</span>抖音商家账号登录，购买“闪电快打”服务
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              &nbsp;&nbsp;购买链接：
              <a
                href="https://fuwu.jinritemai.com/detail?from=fuwu_market_tab&service_id=33"
                target="_blank"
                style={{ cursor: 'pointer' }}>
                <span style={{ color: '#33AAFF' }}>https://fuwu.jinritemai.com/detail?from=fuwu_market_tab&service_id=33</span>
              </a>
            </div>
            <img
              src={require("../../../assets/shan.png")}
              alt=""
              style={{ width: 600, height: 280 }}
            />
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>2.</span>购买后，点击按钮“获取授权链接”，会跳转到新页面，使用抖音商家主账号登录并授权（试用版无法使用此功能，请购买标准版或专业版）
            </div>
            <div>
              <Button type="primary" onClick={this.handleDouSubmit} loading={loading} style={{ marginBottom: 10, marginLeft: 10 }}>
                获取授权链接
              </Button>
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>3.</span>在个人主页，可以看到绑定结果，可以看到店名就是绑定成功
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <br/>
              <span style={{ fontSize: 16 }}>注意：</span>
              如需取消自动下单，则点击下方“取消自动下单”按钮，
              提示取消成功则说明取消成功，也可前往个人中心确认自动下单绑定情况
            </div>
            <div>
              <Button type="primary" onClick={this.handleDouCancel} loading={loadingCancel} style={{ marginBottom: 10, marginLeft: 10 }}>
                取消自动下单
              </Button>
            </div>
          </div>
          ):inputType===4 ?(
            <div style={{marginTop:'15px'}}>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>1.</span>京东商家账号登录，购买“好酷打单”服务
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              &nbsp;&nbsp;购买链接：
              <a
                href=" https://fw.jd.com/main/detail/FW_GOODS-1842802"
                target="_blank"
                style={{ cursor: 'pointer' }}>
                <span style={{ color: '#33AAFF' }}> https://fw.jd.com/main/detail/FW_GOODS-1842802</span>
              </a>
            </div>
            <img
              src={require("../../../assets/jin.png")}
              alt=""
              style={{ width: 600, height: 280 }}
            />
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>2.</span>购买后，点击按钮“获取授权链接”，会跳转到新页面，使用京东商家主账号登录并授权
            </div>
            <div>
              <Button type="primary" onClick={this.handleJinSubmit} loading={loading} style={{ marginBottom: 10, marginLeft: 10 }}>
                获取授权链接
              </Button>
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <span style={{ fontSize: 16 }}>3.</span>在个人主页，可以看到绑定结果，可以看到店名就是绑定成功
            </div>
            <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
              <br/>
              <span style={{ fontSize: 16 }}>注意：</span>
              如需取消自动下单，则点击下方“取消自动下单”按钮，
              提示取消成功则说明取消成功，也可前往个人中心确认自动下单绑定情况
            </div>
            <div>
              <Button type="primary" onClick={this.handleJinCancel} loading={loadingCancel} style={{ marginBottom: 10, marginLeft: 10 }}>
                取消自动下单
              </Button>
            </div>
          </div>
          ):(
            <div style={{textAlign:'center',fontSize: 21, fontWeight: 500}}>因平台风控管理，暂不支持自动下单</div>
          )
        }
      </div>
    );
  }
}
export default AutoList;
